export default __webpack_public_path__ + "static/media/secondary-layout-astronaut.aadb2557.png";